module.exports = __webpack_public_path__ + "img/app_main1.c0d49548.png";